/**
 * Vite exposes `VITE_*` to the browser. Optional `VITE_API_URL` is the FastAPI origin (e.g. http://127.0.0.1:8000).
 */

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/+$/, "");
}

const rawPublic = import.meta.env.VITE_API_URL ?? "";
const rawBackend = (import.meta.env as { VITE_BACKEND_API_URL?: string }).VITE_BACKEND_API_URL ?? rawPublic;

const useMock = import.meta.env.VITE_USE_MOCK === "true";

export const env = {
  /** When true, Axios uses mock adapters; no FastAPI required for listed routes. */
  useMock,
  publicApiUrl: normalizeBaseUrl(rawPublic),
  /** Server-side / direct API base (defaults to same as public in the SPA). */
  backendApiUrl: normalizeBaseUrl(rawBackend),
} as const;
